module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "pg10"
    }
  }), _c('a', {
    attrs: {
      "id": "pg11"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "pg11"
    }
  }, [_c('p', {
    staticClass: "chaptit"
  }, [_vm._v("Establishment of Seneca County and Its Towns")]), _vm._v(" "), _c('p', {
    staticClass: "lev1"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINS OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENECA")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Prior to March 24, 1804, today’s Seneca County was part of various counties. When counties were established in New York State in 1683, the present-day Seneca County was part of the vast Albany County. A portion of Albany County became Tryon County on March 12, 1772. This county was named for William Tryon, colonial governor of New York. In 1784, following the peace treaty that ended the Revolutionary War, Tryon County was renamed Montgomery County in honor of the American general Richard Montgomery. On February 16, 1791, portions of Montgomery County became Tioga, Otsego and Herkimer Counties. Onondaga County was established from a portion of Herkimer County on March 5, 1794. The western portion of Onondaga County became Cayuga County on March 8, 1799. At that time, Cayuga County included the present Seneca and Tompkins Counties and part of Wayne County.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seneca County was established from the western part of Cayuga County by an act passed by the New York State legislature on March 24, 1804. At that time, Seneca County stretched all the way from Lake Ontario to what is today Ithaca. More specifically, it was bounded on the north by Lake Ontario, on the east by Cayuga County, on the south by Tioga County and on the west by Steuben and Ontario Counties. It was a strip some 63 miles in length with an average width of 11 miles, totaling 744 square miles, or about half a million acres.")])]), _c('div', {
    staticClass: "image-break"
  }, [_c('a', {
    attrs: {
      "id": "pg11"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pg11"
    }
  }), _c('a', {
    attrs: {
      "id": "pg12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/p12-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pg12"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Present-day Seneca County was the western part of Cayuga County in 1800. "), _c('i', [_vm._v("Seneca County Historian’s Office.")])])])]), _c('a', {
    attrs: {
      "id": "pg12"
    }
  }), _c('div', {
    staticClass: "image-break"
  }, [_c('a', {
    attrs: {
      "id": "pg12"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pg12"
    }
  }), _c('a', {
    attrs: {
      "id": "pg13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/p13-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pg13"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Seneca County consists of ten towns and is referred to as the “County Between the Lakes.” "), _c('i', [_vm._v("Seneca County Historian’s Office.")])])])]), _c('a', {
    attrs: {
      "id": "pg13"
    }
  }, [_c('p', {
    staticClass: "lev1"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCOUNTERS WITH")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMALS IN THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" 1800"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg13"
    }
  }, [_vm._v("The 1876 Everts history of Seneca County (")]), _c('span', {
    attrs: {
      "href": "#/Chapter04#pg31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("pages 31")]), _vm._v("–"), _c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(") provides true stories of early residents’ encounters with wild animals—something we rarely have to consider today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first of these stories, occurring about 1800, involves young men hunting on Crusoe Island, located near the northeast corner of present-day Seneca County.")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg14"
    }
  }, [_c('i', [_vm._v("A boat-load of young men went to hunt deer upon Crusoe Island. The boat left them, to return in a week. Wolves, numerous and hungry, had driven off the deer. One of the youths went out alone in quest of game. A large black bear was seen upon a chestnut-tree, but disappeared before the hunter reached the spot. He shot and dressed a squirrel, and then set out for camp. It grew dark, and the silence was broken by the prolonged howl of a distant wolf. Here and there an echoing howl replied, and soon a pack had gathered where he had killed the squirrel, and then he knew they were following on his track. He reached and passed a spot where “Indian John”")]), _vm._v(" [who was hanged for the murder of Ezekiel Crane] "), _c('i', [_vm._v("had battled with just such a pack all night. With clubbed rifle he had struck the nearest as their white fangs snapped at him. Morning had come, and the Indian, with torn arms, shattered gun, and dead wolves around him, had seen the pack leave with infinite relief; yet here the white boy was hurrying on and looking for a tree to climb, when the report of a signal gun from camp renewed his courage. The wolves came nearer, and at the discharge of his rifle stopped silent for a moment. Reloading, he hastened on, and again checked pursuit by firing; a third shot was delivered close to camp, the wolves upon his heels. Driven off, the pack continued howling around the fires until daybreak dispersed them in the woods.")]), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/Notes#Bch_1",
      "id": "Ach_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although we still have many squirrels around, they were clearly more numerous in the early 1800s, as evidenced by the following anecdote: “Squirrels were so numerous, and depredated so upon the crops, that the settlers formed in companies, headed by their best marksmen, and gave a day to hunting them. Two thousand squirrels were slain at a single hunt. After the sport, came supper and spirits at some log tavern, the bill being paid by the side having least scalps.”"), _c('span', {
    attrs: {
      "href": "#/Notes#Bch_2",
      "id": "Ach_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Young lads had to learn early on how to use a gun, as illustrated in this 1805 story about an encounter with a panther:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("In the year 1805, or thereabouts, a boy of sixteen…heard his dog barking in the woods about half a mile distant, and purposed to go and see what he had there. It was about nine o’clock and the night was very dark; the mother objected to his going, as her husband was away at the time. The boy gained his point and set off with gun and axe, accompanied by his younger brother, carrying a lighted torch of hickory-bark. The dog barked louder as the light drew near. Pushing their way through a thicket, they found there was something concealed in the thick leaves and "), _c('a', {
    attrs: {
      "id": "pg15"
    }
  }, [_vm._v("branches of a large tree-top. While the younger boy held the torch, the elder, creeping under the top from the opposite side, groped his way up to some animal which turned towards him, and then to the dog, which had come closer. The glimmer of the light gave to it a white appearance, and the boys, concluding it was a stray sheep, called off the dog and went home. The father discredited the idea of a sheep, and next day saw signs of some animal and tracks of the dog, but no sheep. One day, some weeks later, father and son were seated upon a log, resting from their work of getting out timber, and eating their luncheon, part of which was roast venison, when their dog, growling, crouched at their feet. Set on, he bounded forward with a bark, and back and tail of an animal were seen as it leaped away through the brush. The father, turning pale, exclaimed, “My God! what a panther!” The panther prowled about the house all night. The father being called away on a journey, the boy determined to try a shot at the wild beast during his absence. The gun was cleaned and loaded with two balls, and John Updike and brother invited to come over and help “top” turnips and bring their “bear” dog. Night came; the dog was left out-doors, a torch made ready to light, and turnip-topping began. Presently the large dog in the house began to growl, and the dog outside was heard loudly barking. The torch was lighted, the boy stole out, and some eight rods off saw the panther’s glaring eyes fixed upon the house. Gun in hand at the corner of the house, the boy could presently see the dark form outlined by the torchlight held by John Updike, while by him his brother William held their dog. The gun was aimed between the panther’s eyes, the trigger pulled, and the gun flashed. The torch fell, the dogs sprang out and seized the animal as he bounded upon his assailant. The Updike boys rushed into the house and closed the door. The panther’s paw struck close to the youth as the dogs caught and held him. Successive blows laid out the wounded animal, and the fierce panther escaped to the woods and troubled them no more.")])]), _c('span', {
    attrs: {
      "href": "#/Notes#Bch_3",
      "id": "Ach_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "lev1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBSEQUENT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDARY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANGES TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENECA")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The southwestern portion of the town of Ovid was taken away on March 30, 1802, to become part of the town of Hector. On April 7, 1817, Ovid was divided, the southern portion becoming the town of Covert. On that same day, the town of Covert was taken away from Seneca County and "), _c('a', {
    attrs: {
      "id": "pg16"
    }
  }, [_vm._v("became part of Tompkins County. The former town of Covert was returned to Seneca County on April 13, 1819.")])]), _c('a', {
    attrs: {
      "id": "pg16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The northern portions of Seneca County (the towns of Galen and Wolcott) were taken away from Seneca County on April 11, 1823, to become parts of the newly created Wayne County. At this point, Seneca County totaled about 197,500 acres of land.")]), _vm._v(" "), _c('p', {
    staticClass: "lev1"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTORY OF THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMATION OF THE")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARIOUS")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWNS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the time of Seneca County’s creation, on March 24, 1804, it consisted of the towns of Ovid, Romulus, Washington and Junius. Ovid and Romulus had been established on March 5, 1794. The town of Washington was formed from the northern portion of Romulus on March 14, 1800. Junius was created from the northern portion of Washington on February 12, 1803.")]), _vm._v(" "), _c('div', {
    staticClass: "image-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/p16-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The boundaries of Seneca County itself, as well as the various towns of the county, have changed greatly since 1804. "), _c('i', [_vm._v("Seneca County Historian’s Office.")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pg16"
    }
  }), _c('a', {
    attrs: {
      "id": "pg17"
    }
  }, [_vm._v("The town of Washington was renamed Fayette on April 6, 1808. This change was made by the New York State legislature to avoid confusing this portion of Seneca County with the town of Washington in Dutchess County, which had been organized by the legislature on March 13, 1786. Virtually everyone at the time remembered the crucial contributions that General Gilbert Motier de LaFayette, the beloved companion-in-arms to General George Washington, had made during the American Revolution.")]), _c('span', {
    attrs: {
      "href": "#/Notes#Bch_4",
      "id": "Ach_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Covert was formed from the southern portion of the town of Ovid on April 7, 1817. On March 30, 1843, Lots 34, 40, 41 and 42 of Military Tract Township No. 16 (Ovid) were transferred from the town of Ovid to the town of Covert.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The town of Lodi was formed from the western portion of Covert on January 27, 1826. On May 5, 1837, the north line of the town was advanced one mile with the annexation of Military Lots 26, 35, 36, 37, 38 and 39 from the town of Ovid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The towns of Seneca Falls, Tyre and Waterloo were formed from portions of Junius on March 26, 1829.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The town of Varick was formed from the northern portion of Romulus on February 6, 1830.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6c9128","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter01.vue
// module id = 72
// module chunks = 0